import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ORDER_INVOICE_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { OrderInvoiceBlockScenarioContent } from '@front-platform/content-builder';
import { DoodOrderPaymentModel } from '@store/order/order.model';

import {
  ORDER_INVOICE_BLOCK_EMPTY_VM,
  OrderInvoiceBlockDataSource,
  OrderInvoiceBlockViewModel,
} from './order-invoice-block-view-model';

@Injectable()
export class OrderInvoiceBlockPreviewDataSource implements OrderInvoiceBlockDataSource {
  readonly vm$: Observable<OrderInvoiceBlockViewModel> = previewScenarioForBloc$(
    ORDER_INVOICE_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return ORDER_INVOICE_BLOCK_EMPTY_VM;
      }

      const content = previewScenarioData<OrderInvoiceBlockScenarioContent>(
        scenario,
        ORDER_INVOICE_BLOCK_COMPONENT,
      );
      if (!content) {
        return ORDER_INVOICE_BLOCK_EMPTY_VM;
      }

      return {
        payments: content.payments as unknown as readonly DoodOrderPaymentModel[],
      };
    }),
  );
}
